import BaseLayout from '../base/BaseLayout/BaseLayout';
import { FC, Children, isValidElement } from 'react';
import { LayoutProps } from '../types/layout.types';

const SandSplitLayout: FC<LayoutProps> = ({ children, navigation, footer }) => {
  const contentElements = Children.toArray(children);

  const layoutContent: {
    displayContent: JSX.Element;
    colorTheme: string;
  }[] = [];

  contentElements.forEach((ce, i) => {
    if (isValidElement(ce)) {
      const props = {
        displayContent: ce as JSX.Element,
        colorTheme: i ? 'sand' : 'snow',
      };
      layoutContent.push(props);
    }
  });

  return (
    <BaseLayout
      layoutContent={layoutContent}
      navigation={navigation}
      footer={footer}
    />
  );
};

export default SandSplitLayout;
